import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	realtimeUpdateExceededMaxHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	realtimeUpdateExceededMaxDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	realtimeUpdateExceededMaxRefreshButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	realtimeUpdateExceededMaxHeader: {
		id: 'jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-header',
		defaultMessage: 'Updating those work items',
		description:
			'Header that shows when the data could be stale because we could not process the real time updates',
	},
	realtimeUpdateExceededMaxDescription: {
		id: 'jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-description',
		defaultMessage: 'Refresh the page to see the updates',
		description:
			'Description that shows when the data could be stale because we could not process the real time updates',
	},
	realtimeUpdateExceededMaxRefreshButton: {
		id: 'jira-issue-realtime-updates.ui.flag.info.realtime-update-exceeded-max-refresh-button',
		defaultMessage: 'Refresh',
		description: 'Call to action to refresh the page  when the data could be stale',
	},
});
export default messages;
